import App from '../app'
import Vue from 'vue'
import GLightbox from 'glightbox'

/* eslint-disable no-new */
new Vue({
  extends: App,
  mounted () {
    console.dir('mounted')
    GLightbox();
  }
})
